/* Gender Select Styling */
.options {
    display: flex;
    flex-flow: row wrap;
}

.options > div {
    margin-right: 20px;
}
